const TraderNewsApiTranslations = {
  'en-US': {
    socialNews: {
      pageTitle: 'Trader News API',
      hero: {
        title1: 'TRADER NEWS',
        title2: 'API',
        desc:
          'Our Trader News API provides traders with real-time market insights by analyzing social media posts, financial news, and discussions. ' +
          'Using AI-driven sentiment analysis, our system detects market-moving events and delivers instant alerts, enabling traders to make informed decisions with confidence.',
      },
      features: {
        socialNewsAPI: {
          title: 'Real-Time Trader News API',
          desc: 'Stay ahead of market trends with our Trader News API. Our system continuously monitors and analyzes social media platforms, financial news sources, and online discussions to identify potential market-moving events. Users receive real-time alerts via API and webhooks, ensuring they never miss crucial information.',
        },
        marketImpactAlerts: {
          title: 'Market Impact Alerts',
          desc: 'Our AI-powered system evaluates news sentiment, engagement levels, and trading volume to assess its potential impact on financial markets. Traders receive actionable insights that help them seize emerging opportunities while mitigating risks.',
        },
        sentimentAnalysis: {
          title: 'Sentiment Analysis & Trend Detection',
          desc: 'By leveraging natural language processing (NLP) and AI-driven sentiment analysis, our platform detects bullish and bearish trends in real-time. Traders can integrate these insights into their strategies, ensuring a proactive approach to market changes.',
        },
        customizableAlerts: {
          title: 'Customizable Alerts & Webhooks',
          desc: 'Our Trader News API allows traders to configure personalized alerts based on keywords, sentiment scores, and market relevance. Webhook integration ensures seamless connectivity with trading platforms and automation tools.',
        },
      },
    },
  },
}

export default TraderNewsApiTranslations
